import { render, staticRenderFns } from "./RealEstateEmploymentCoefficientList.vue?vue&type=template&id=b9c452ca&scoped=true&"
import script from "./RealEstateEmploymentCoefficientList.vue?vue&type=script&lang=js&"
export * from "./RealEstateEmploymentCoefficientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c452ca",
  null
  
)

export default component.exports